var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOssWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 23,
    viewBox: "0 0 65 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9937 14.0334L10.9629 14.0355L10.981 22.5554L12.0118 22.5533L11.9937 14.0334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97054 13.6657L6.86938 21.6171L7.83145 21.9824L10.9326 14.0311L9.97054 13.6657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18037 12.9655L3.37744 19.274L4.14074 19.9577L9.94367 13.6492L9.18037 12.9655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70169 12.0341L0.980957 15.8476L1.44237 16.7572L9.1631 12.9437L8.70169 12.0341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59546 10.9893L0 11.7926L0.0971916 12.8053L8.69265 12.002L8.59546 10.9893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.568809 7.66486L0.288818 8.64386L8.59817 10.9579L8.87816 9.97893L0.568809 7.66486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.60829 4.01599L1.98877 4.82904L8.88956 9.9493L9.50908 9.13626L2.60829 4.01599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85095 1.34556L4.97559 1.88281L9.53552 9.11752L10.4109 8.58027L5.85095 1.34556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85031 0.00401143L8.8374 0.193054L10.4419 8.56452L11.4548 8.37548L9.85031 0.00401143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0523 -2.41904e-05L11.4863 8.37854L12.5001 8.56305L14.0661 0.184481L13.0523 -2.41904e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.059 1.32273L12.5286 8.57544L13.4061 9.10922L17.9366 1.85651L17.059 1.32273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3104 3.97925L13.4314 9.12799L14.0544 9.93847L20.9334 4.78973L20.3104 3.97925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3644 7.6195L14.0649 9.9679L14.3491 10.9457L22.6485 8.59734L22.3644 7.6195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3533 10.9759L14.2603 11.989L22.8589 12.7582L22.952 11.7451L14.3533 10.9759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.252 12.0172L13.7944 12.9288L21.5313 16.7103L21.9888 15.7988L14.252 12.0172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.778 12.9571L13.0176 13.6439L18.8472 19.9284L19.6076 19.2416L13.778 12.9571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9897 13.6608L12.0293 14.0303L15.1656 21.9682L16.126 21.5987L12.9897 13.6608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.709 8.94219L32.82 8.42439C31.0858 8.15263 29.7051 7.55036 29.7051 5.94187C29.7051 4.33338 31.1416 3.26105 33.2071 3.26105C35.3916 3.26105 36.8467 4.28196 37.2263 6.15487L41.48 4.9283C40.6166 1.86188 37.6059 0.00366211 33.3671 0.00366211C28.4733 0.00366211 25.4663 2.47516 25.4663 6.36419C25.4663 9.5922 27.502 11.4761 31.6366 12.0527L35.7935 12.6146C37.7585 12.9157 39.169 13.6648 39.169 15.703C39.169 17.9909 37.271 19.4562 34.2082 19.4562C30.509 19.4562 28.2054 17.3409 28.2054 13.8191L23.5684 15.1558C24.2085 19.7757 28.09 23.0073 34.1263 23.0073C40.1626 23.0073 43.538 19.996 43.538 15.4349C43.538 11.7112 41.2121 9.5518 36.709 8.94953V8.94219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1709 8.94219L54.282 8.42439C52.5477 8.15263 51.1671 7.55036 51.1671 5.94187C51.1671 4.33338 52.6036 3.26105 54.669 3.26105C56.8535 3.26105 58.3086 4.28196 58.6882 6.15487L62.9419 4.9283C62.0785 1.86188 59.0678 0.00366211 54.829 0.00366211C49.9352 0.00366211 46.9282 2.47516 46.9282 6.36419C46.9282 9.5922 48.9639 11.4761 53.0985 12.0527L57.2555 12.6146C59.2204 12.9157 60.6309 13.6648 60.6309 15.703C60.6309 17.9909 58.7329 19.4562 55.6701 19.4562C51.9709 19.4562 49.6673 17.3409 49.6673 13.8191L45.0303 15.1558C45.6704 19.7757 49.5519 23.0073 55.5882 23.0073C61.6245 23.0073 64.9999 19.996 64.9999 15.4349C64.9999 11.7112 62.674 9.5518 58.1709 8.94953V8.94219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOssWhite);
export default __webpack_public_path__ + "static/media/oss-white.b84d8b7291674fa7b74644d880257adb.svg";
export { ForwardRef as ReactComponent };